<template>
  <div class="l-page l-page--abtest-detail">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <!-- パンくずリスト -->
      <breadcrumb :breadcrumb-data="breadcrumbData" />
      <!-- /パンくずリスト -->

      <div class="l-main-content">
        <div class="p-abtest-detail is-loading">
          <!-- 基本情報 -->
          <div class="p-abtest-detail-list">
            <div class="c-loader c-loader"></div>
            <div class="p-abtest-detail-list__item">
              <h2 class="c-title u-w100p">
                <div class="c-title__text u-fs24">-</div>
              </h2>
            </div>
            <div class="p-abtest-detail-list__item">
              <div class="p-abtest-detail__title">テスト項目</div>
              <div class="p-abtest-detail__text p-abtest-detail__text--type">-</div>
              <div class="p-abtest-detail__title">検証結果集計日</div>
              <div class="p-abtest-detail__text">-</div>
            </div>
            <div class="p-abtest-detail-list__item p-abtest-detail-list__item--desc">
              <div class="p-abtest-detail__title">テストした内容</div>
              <div class="p-abtest-detail__text">-</div>
            </div>
          </div>
          <div class="p-abtest-detail-result">
            <div class="c-loader c-loader"></div>
            <div class="p-abtest-detail-result__image">
              <div class="c-icon c-icon--yellow u-wh48">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#crown" />
                </svg>
              </div>
            </div>
            <div class="p-abtest-detail-result-content">
              <div class="p-abtest-detail-result__title">テスト結果</div>
              <div class="p-abtest-detail-result__text">-</div>
            </div>
          </div>
          <div class="p-abtest-detail-match">
            <div class="p-abtest-detail-match__item">
              <div class="p-abtest-detail-match__text">A</div>
            </div>
            <!-- <div class="p-abtest-detail-match__item p-abtest-detail-match__item--victory"> -->
            <div class="p-abtest-detail-match__item">
              <div class="p-abtest-detail-match__text">B</div>
            </div>
          </div>
          <div class="p-abtest-detail-preview">
            <div class="p-abtest-detail-preview-list">
              <div class="c-loader c-loader"></div>
              <div class="p-abtest-detail-preview-list__item">
                <div class="p-abtest-detail-preview-content">
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">性別</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">年齢</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">地域</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">オーディエンス</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                </div>
              </div>
              <div class="p-abtest-detail-preview-list__item">
                <!-- <div class="p-abtest-detail-preview-content p-abtest-detail-preview-content--victory"> -->
                <div class="p-abtest-detail-preview-content">
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">性別</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">年齢</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">地域</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                  <div class="p-abtest-detail-preview-content-row">
                    <div class="p-abtest-detail-preview-content__title">オーディエンス</div>
                    <div class="p-abtest-detail-preview-content__text">-</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-abtest-detail-compare">
            <div class="p-abtest-detail-compare-list">
              <div class="p-abtest-detail-compare-list__item">
                <div class="p-abtest-detail-compare-row" data-type="impression">
                  <div class="p-abtest-detail-compare-row__title">表示回数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span></span></div>
                  <div class="p-abtest-detail-compare-row__value">-</div>
                </div>
                <div class="p-abtest-detail-compare-row" data-type="click">
                  <div class="p-abtest-detail-compare-row__title">クリック数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span></span></div>
                  <div class="p-abtest-detail-compare-row__value">-</div>
                </div>
                <div class="p-abtest-detail-compare-row" data-type="ctr">
                  <div class="p-abtest-detail-compare-row__title">クリック率</div>
                  <div class="p-abtest-detail-compare-row__bar"><span></span></div>
                  <div class="p-abtest-detail-compare-row__value">-</div>
                </div>
              </div>
              <div class="p-abtest-detail-compare-list__item">
                <div class="p-abtest-detail-compare-row" data-type="impression">
                  <div class="p-abtest-detail-compare-row__title">表示回数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span></span></div>
                  <div class="p-abtest-detail-compare-row__value">-</div>
                </div>
                <div class="p-abtest-detail-compare-row" data-type="click">
                  <div class="p-abtest-detail-compare-row__title">クリック数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span></span></div>
                  <div class="p-abtest-detail-compare-row__value">-</div>
                </div>
                <div class="p-abtest-detail-compare-row" data-type="ctr">
                  <div class="p-abtest-detail-compare-row__title">クリック率</div>
                  <div class="p-abtest-detail-compare-row__bar"><span></span></div>
                  <div class="p-abtest-detail-compare-row__value">-</div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-abtest-detail__data">
            <div class="c-loader c-loader"></div>
            <table class="c-table c-table--abtest-detail">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w160">比較指標</th>
                  <th class="c-table__cell--center u-w250">合計数・平均</th>
                  <th class="c-table__cell--center u-w250">Aパターン</th>
                  <th class="c-table__cell--center u-w250">Bパターン</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-abtest-detail__btns">


          <button
            class="c-btn c-btn--modal c-btn--blue u-w400 u-h50 u-fs--xl"
            type="button"
            name="edit"
            value="edit"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">この結果を引き継ぎテストを行う</p>
          </button>


          <div class="c-text">成果の良かった結果を元にさらに比較のテストを行うことができます。</div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    linkData: Object,
  },
  data () {
    return {
    }
  },
  mounted: function() {
    import('../../funcs/pages/abtest-result').then(module => {
      module.AbtestResult();
    });
  },
  methods: {
    onNextClick: function(event) {
      location.href = this.linkData.abtestUrl;
      event.preventDefault();
    },
  }
}
</script>
